module.exports = __webpack_public_path__ + "static/media/tm.7954473d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tm.png
// module id = 2000
// module chunks = 0